import { OctreeLoader } from './OctreeLoader';
export async function loadOctree(metadataUrl, getUrl, xhrRequest) {
    const loader = new OctreeLoader();
    const { geometry } = await loader.load(metadataUrl, getUrl, xhrRequest);
    return geometry;
}
